import CWListeDetailTPL from './cwListeDetailPanel.tpl.html';
import { CWSplitPanelView } from './cwSplitPanel.view';


export class CWListeDetailPanelView extends CWSplitPanelView {

  firstTemplate = CWListeDetailTPL;

}
